//import * as h from '../helpers/helpers';
import {Buffer} from 'buffer';
import { decStateLoadingCount, incStateLoadingCount } from '../store/store';
import { getJPGDimensions, getPNGDimensions } from '../helpers/imageHelpers';

export var dirHandles = [];

export function setDirHandles(h) {
	dirHandles = h;
}

export async function openFiles(win, multiple) {
	var fileOrFiles = [];
	try {
		const handles = await win.showOpenFilePicker({multiple});
		console.log("handles:", handles);
		if (!multiple) {
			// Add the `FileSystemFileHandle` as `.handle`.
			const file = await handles[0].getFile();
			file.handle = handles[0];
			fileOrFiles.push(file);
		} else {
			fileOrFiles = await Promise.all(
				handles.map(async (handle) => {
					const file = await handle.getFile();
					// Add the `FileSystemFileHandle` as `.handle`.
					file.handle = handle;
					return file;
				})
			);
		}
	} catch (error) {
			console.log("showOpenFilePicker", error);
			alert("showOpenFilePicker: " + error);
	}
	return fileOrFiles;
}
		
export async function openDirectory(win) {
	try {
		const dirEntries = await win.showDirectoryPicker({mode:"read"});
		const dirhandles = await getDirecoryEntries(dirEntries);
		const handles = getFileHandles(dirhandles)
		return handles;
	} catch (error) {
			console.log("showOpenFilePicker", error);
			if (error.code !== 20) {
				alert(error);
			}
	}
	return null;
}

export function getFileHandles(dirHandles) {
	const handles = [];

	dirHandles.forEach(dh => {
		handles.push(dh.handle);
	})
	return handles;
}

export async function getDirecoryEntries(dirHandle, path = dirHandle.name)  {
	const dirs = [];
	const files = [];
	for await (const entry of dirHandle.values()) {
		const nestedPath = `${path}/${entry.name}`;
		if (entry.kind === "file") {
			files.push(
				entry.getFile().then((file) => {
					file.directoryHandle = dirHandle;
					file.handle = entry;
					file.handle.nestedPath = nestedPath;
					return Object.defineProperty(file, "webkitRelativePath", {
						configurable: true,
						enumerable: true,
						get: () => nestedPath,
					});
				})
			);
		} else if (entry.kind === "directory") {
			const dir = getDirecoryEntries(entry, nestedPath);
			dirs.push(dir);
		}
	}
	return [
		//...(await Promise.all(dirs)).flat(),
		...((await Promise.all(dirs)).flat()),
		...(await Promise.all(files)),
	];
};

export async function readFile(handle) {
	return await readFileX(handle);
}

export async function readFileX(handle) {
	var data = null;
	try {
		var file = await handle.getFile();
		data = await file.text(file.handle);
		//console.log("data: ",data.length);
		} catch (error) {
				console.log("readFile error:", file.handle.filename, error);
				alert("readFile: " + error);
			return null;
		}
		return data;
}

export async function readBinaryFile(handle) {
	var bufferInstance = null;
	try {
		var file = await handle.getFile();
		let arrayBuffer = await file.arrayBuffer(file.handle);
		bufferInstance =  Buffer.from(arrayBuffer);
		//console.log("readBinaryData: ", typeof data, data.length);
		} catch (error) {
				console.log("readBinaryFile error:", handle, error);
				alert("readBinaryFile: " + error);
			return null;
		}
		return bufferInstance;
}

export function getXmlHandles(handles) {
	let xmlHandles = [];
	for (let i = 0; i < handles.length; ++i) {
		let handle = handles[i];
		let name = handle.name.toLowerCase();
		if (name.endsWith(".xml")) {
			xmlHandles.push(handle);
			}
	}
	return xmlHandles;
}

export async function getImageFileData(handle) {
	var data = await readBinaryFile(handle);
	return data;
}

export async function getImageFile(fn) {
	var filename = fn.replace(/^.*[\\/]/, '');
	filename = filename.toLowerCase();
	var handle = null;
	for (let dh of dirHandles) {
		let name = dh.name.toLowerCase();
		if (name === filename) {
			handle = dh;
			break;
		}
	}

	if (!handle) 	{
		// try for another file
		let fn1 = filename.replace(".png", ".jpg");
		for (let dh of dirHandles) {
			let name = dh.name.toLowerCase();
			if (name === fn1) {
				handle = dh;
				filename = name;
				break;
			}
		}
		if (handle) {
			let msg = "png file was actually a jpg: " + filename;
			global.ptr.warnings.push(msg);
			console.log(msg);
		}
	}

	if (!handle) 	{
		let msg = "Missing file: " + filename;
		global.ptr.warnings.push(msg);
		console.log(msg);
		return null;
	}
	
	incStateLoadingCount();
	let bufferInstance = await getImageFileData(handle);
	decStateLoadingCount();

	let data = bufferInstance.toString('base64');
	let height = 0;
	let width = 0;

	if (filename.endsWith(".png")) {
		let pdim = getPNGDimensions(bufferInstance);
		height = pdim.height;
		width = pdim.width;
		data = 'data:image/png;base64,' + data;
	}	else if (filename.endsWith(".jpg") || filename.endsWith(".jpeg")) {
		let jdim = getJPGDimensions(bufferInstance);
		height = jdim.height;
		width = jdim.width;
		data = 'data:image/jpeg;base64,' + data;
	} else {
		console.log("Unknown image file:", filename)
		return null;
	}

	let id = {
		data: data,
		height: height,
		width: width,
		img: null		
	}

	//console.log(height, width, filename);

	return id;
}

